"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResponsiveAdManager_1 = require("../../components/ResponsiveAdManager");
var _globals_1 = require("../_globals");
var jquery_1 = __importDefault(require("jquery"));
googletag.cmd.push(function () {
    googletag.pubads().disableInitialLoad();
    googletag.pubads().setRequestNonPersonalizedAds(0);
    if (!siteData) {
        return;
    }
    googletag.pubads().setTargeting("mediaPlatform", "browser");
    googletag.pubads().setTargeting("dartSection", siteData.section);
    googletag.pubads().setTargeting("dartSubSection", siteData.subSection);
    googletag.pubads().setTargeting("subscription", siteData.subscriptions);
    googletag.pubads().setTargeting("Tag", siteData.tags);
    googletag.pubads().setTargeting("Interest", siteData.interests);
    googletag.pubads().setTargeting("ageGroup", siteData.ageGroup);
    googletag.pubads().setTargeting("companyBranch", siteData.companyBranch);
    googletag.pubads().setTargeting("companyFunction", siteData.companyFunction);
    googletag.pubads().setTargeting("title", siteData.title);
    googletag.pubads().setTargeting("isin", siteData.isin);
    googletag.pubads().setTargeting("articleSource", siteData.articleSource);
    googletag.pubads().setTargeting("articleId", siteData.articleId);
});
(0, jquery_1.default)(function () {
    var responsiveAdManager = new ResponsiveAdManager_1.ResponsiveAdManager({
        desktopMode: (0, jquery_1.default)(_globals_1.root).hasClass("desktop-mode")
    });
    if (siteData && siteData.adslotsDisabled == true) {
        console.log('Slots are disabled');
    }
    else {
        responsiveAdManager.process();
        if (window.__cmp) {
            window.__cmp('addEventListener', 'cmpReady', function (ready) {
                window.__cmp('getVendorConsents', undefined, function (data) {
                    var newConsentForAds = (data.purposeConsents[1] && data.purposeConsents[2] && data.purposeConsents[3] && data.purposeConsents[4] && data.purposeConsents[5]);
                    console.log('consentForAds: ' + newConsentForAds, data.purposeConsents);
                    googletag.cmd.push(function () {
                        googletag.pubads().setRequestNonPersonalizedAds(newConsentForAds ? 0 : 1);
                        googletag.pubads().refresh();
                    });
                });
            });
        }
        else {
            googletag.cmd.push(function () {
                googletag.pubads().refresh();
            });
        }
    }
});
